<template>
  <div class="content-cliente-data">
    <h2>Dados do cliente</h2>
    <div class="profile-wrapper">
      <img v-if="data.profilePicture" :src="data.profilePicture" @error="(() => data.profilePicture = null)" />
      <div v-else class="profile-name">{{ parseFirstLetterProfileFullName(data.name) }}</div>

      <a @click="contactOpen">Editar dados</a>
    </div>

    <h2>{{ data.name ? parseFirstNameUpperCase(data.name) : 'Sem registro' }} <div v-if="data.rating" :class="(data.rating === 'A' || data.rating === 'B') ? 'score' : ((data.rating === 'D' || data.rating === 'E') ? 'score-danger' : 'score-warning')">{{ data.rating }}</div></h2>

    <div class="info spc">{{ data.spcName ? parseFirstNameUpperCase(data.spcName) : 'S/ nome SPC' }} <span v-if="data.spcName">SPC</span></div>
    <div class="info social">{{ socialName ? socialName.replace('Nome:', '') : 'S/ nome Social' }} <span v-if="socialName">SOCIAL</span></div>

    <div class="default-phone-number">
      <div v-for="phone in phones" v-bind:key="'B-' + phone.id">
          <div class="info source-email" v-if="phone.default">{{ phone.phoneNumber | phone-format }}<span class="icon-star checked"></span>
            <template v-if="phone.source">
              <span v-if="phone.source.split(' ').slice(0, -1).length < 1" class="source-badge">{{ phone.source }}</span>
              <div v-for="source in (phone.source.split(' ').slice(0, -1))" v-bind:key="source.id"><span v-if="phone.source.split(' ').slice(0, -1).length >= 1" class="source-badge">{{source}}</span></div>
            </template>
          </div>
      </div>
    </div>

    <div v-for="phone in phones" v-bind:key="'B-' + phone.id">
      <div class="info source-email" v-if="!phone.default && !phone.disabled">{{ phone.phoneNumber | phone-format }}
        <template v-if="phone.source">
          <span v-if="phone.source.split(' ').slice(0, -1).length < 1 && phone.source.split(' ').slice(0, -1).length >= 0" class="source-badge" >{{ phone.source }}</span>
          <div v-for="source in (phone.source.split(' ').slice(0, -1))" v-bind:key="source.id"><span v-if="phone.source.split(' ').slice(0, -1).length >= 1" class="source-badge">{{source ? source : ''}}</span></div>
        </template>
      </div>
    </div>

    <div class="default-email">
      <div v-for="email in emails" v-bind:key="'B-' + email.id">
          <div class="info source-email" v-if="email.default">{{ email.email }}<span class="icon-star checked"></span>
            <template v-if="email.source">
              <span v-if="email.source.split(' ').slice(0, -1).length < 1" class="source-badge" >{{ email.source }}</span>
              <div v-for="source in (email.source.split(' ').slice(0, -1))" v-bind:key="source.id"><span v-if="email.source.split(' ').slice(0, -1).length >= 1" class="source-badge">{{source}}</span></div>
            </template>
          </div>
      </div>
    </div>

    <div v-for="email in emails" v-bind:key="'B-' + email.id">
      <div class="info source-email" v-if="!email.default && !email.disabled">{{ email.email }}
        <template v-if="email.source">
          <span v-if="email.source.split(' ').slice(0, -1).length < 1 && email.source.split(' ').slice(0, -1).length >= 0" class="source-badge" >{{ email.source }}</span>
          <div v-for="source in (email.source.split(' ').slice(0, -1))" v-bind:key="source.id"><span v-if="email.source.split(' ').slice(0, -1).length >= 1" class="source-badge">{{source ? source : ''}}</span></div>
        </template>
      </div>
    </div>
    <div class="info cpf" v-if="data.cpf">{{ data.cpf | cpf-format }} <div v-if="cpfStatus" v-b-tooltip.hover :title="check.cpf" :class="cpfStatus === 'OK' ? 'icon success' : cpfStatus === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-fingerprint"></i></div></div>
    <div class="info cpf" v-else>{{ 'S/ cpf' }} <div v-if="cpfStatus" :class="cpfStatus === 'OK' ? 'icon success' : cpfStatus === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-fingerprint"></i></div></div>
    <div class="info birthday" v-if="data.birthDate">{{ data.birthDate | moment-date-dash }}</div>
    <div class="info birthday" v-else>{{ 'S/ data nascimento' }}</div>

    <button @click="openWhatsapp"><i class="icon-whatsup"></i>Chamar no whatsapp</button>
  </div>
</template>

<script>
import { parseFirstLetterProfileFullName } from '../../../utils/parseFirstLetterProfileFullName'
import { parseFirstNameUpperCase } from '../../../utils/parseFirstNameUpperCase'

export default {
  data () {
    return {
      data: {},
      display: 'show',
      phones: [],
      emails: []
    }
  },
  mounted () {
    this.getCustomerData()
    this.loadPhones()
  },
  methods: {
    parseFirstNameUpperCase,
    parseFirstLetterProfileFullName,
    contactOpen () {
      this.$emit('emitContactOpen')
    },
    getCustomerData () {
      this.$http.get('api/order-validation/' + this.$route.params.txid + '/customer-data')
        .then(function (res) {
          this.data = res.data.resp
          this.emails = res.data.emailsList
          this.phones = res.data.phonesList
          this.$emit('emit-customer-phone-number', this.data.phoneNumber)
          this.$emit('emit-customer-name', this.data.name)
          this.$emit('emit-customer-cpf', this.data.cpf)
          this.$emit('emit-customer-profile-picture', this.data.profilePicture)
          if (this.data.device) this.$emit('emit-customer-device', this.data.device.os)
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
        })
    },
    openWhatsapp () {
      this.$emit('emitWhastappOpen')
      this.$emit('emitWhatsappScrollbar')
    },
    getSourceName (items, defaultItem) {
      let sourceName = ''
      let finalSourceName = ''
      items.forEach(e => {
        switch (true) {
          case e.source === 'SPC':
            sourceName = 'SPC'
            break
          case e.source === 'Facebook':
            sourceName = 'Social'
            break
          case e.source === 'Jornada BoletoFlex':
            sourceName = null
            break
          case e.source === 'Atendimento BoletoFlex':
            sourceName = null
            break
          case e.source === '':
            sourceName = null
            break
          default:
            sourceName = 'Loja'
            break
        }
        if (defaultItem === e.email || defaultItem === e.phoneNumber) {
          finalSourceName = sourceName
        }
      })
      return finalSourceName.toUpperCase()
    }
  },
  watch: {
    'isUpdateCustomerData' () {
      if (this.isUpdateCustomerData) {
        this.getCustomerData()
        this.loadPhones()
        this.loadEmails()
      }
    }
  },
  props: ['cpfStatus', 'isUpdateCustomerData', 'socialName', 'check']
}
</script>

<style lang="scss" scoped>
.content-cliente-data {
  .profile-wrapper {
    display: flex;
    align-items: center;

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin: 0 10px 10px 0;
    }

    a {
      color: #4285F4;
      cursor: pointer;
    }
  }
  .profile-name {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin: 0 10px 10px 0;
    background-color: #6e58f1;
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: bold;
  }

  .source-badge {
    margin-left: 8px;
    padding: 2px 8px;
    font-size: 12px !important;
    border-radius: 4px ;
    color: #ffffff !important;
    background-color: #4285F4;
  }

  button {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 8px;
    border-radius: 5px;
    border: none;
    background-color: #1c56e0;
    font-size: 12px;
    color: #ffffff;
    i {
      margin: 0 4px 0 0;
      &::before {
        font-size: 16px;
      }
    }
  }
  a {
    position: relative;
    top: -5px;
  }

  .default-phone-number {
    display: flex;
    align-items: center;

    span {
      color: orange;
      margin-left: 5px;
      font-size: 15px;
    }
  }

  .default-email {
    display: flex;
    align-items: center;
    flex-direction: row;

    span {
      color: orange;
      margin-left: 5px;
      font-size: 15px;
    }
  }
}
h2 {
  .score {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    margin-left: 8px;
    border-radius: 50%;
    color: #ffffff;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    background-color: #4285F4
  }
  .score-danger {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    margin-left: 8px;
    border-radius: 50%;
    color: #ffffff;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    background-color: #e74c3c
  }
  .score-warning {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    margin-left: 8px;
    border-radius: 50%;
    color: #ffffff;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    background-color: #f1c40f
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/CustomerData.vue